export const Logo = ({ light = false, compact = false }) => (
  <div className="flex items-center gap-2.5" data-testid="ntn-logo">
    <img
      src="/ntn-logo.png"
      alt="National Tenant Network"
      className={`h-10 w-10 object-contain ${light ? "" : ""}`}
      data-testid="ntn-logo-mark"
    />
    {!compact && (
      <div className="leading-tight">
        <div className={`font-serif text-base font-semibold ${light ? "text-white" : "text-[#0A192F]"}`}>
          NTN Verify Hub
        </div>
        <div className={`text-[10px] tracking-[0.2em] uppercase font-bold ${light ? "text-white/60" : "text-[#4A5568]"}`}>
          Applicant Verification
        </div>
      </div>
    )}
  </div>
);
